module.exports = __webpack_public_path__ + "assets/functionalityTrashSmall-5b6779.svg";